import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Recipe } from '../models/recipe-model';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';


@Injectable()
export class DragDropService {

  constructor() { }
  private recipeSubject = new BehaviorSubject<Recipe>(null);
  private recipeClearSubject = new Subject();
  private isShowPlanMenu = new Subject<any>();

  public getSubscription(): Observable<Recipe>  {
    return this.recipeSubject.asObservable();
  }

  public getClearRecipeSubscription(): Observable<any> {
    return this.recipeClearSubject.asObservable();
  }

  public getShowPlanMenu(): Observable<any>  {
    return this.isShowPlanMenu.asObservable();
  }

  public emitShowPlanMenu(isShowPlanMenu): void {
    this.isShowPlanMenu.next(isShowPlanMenu);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/drag-drop.service.ts